export function Settings() {
  return (
    <div>
      <div className="md:flex md:items-center md:justify-between">
        <div className="flex-1 min-w-0">
          <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
            Settings
          </h2>
        </div>
      </div>

      <div className="mt-8 space-y-6">
        {/* Profile Settings */}
        <div className="card">
          <div className="card-header">
            <h3 className="text-lg leading-6 font-medium text-gray-900">
              Profile Information
            </h3>
            <p className="mt-1 text-sm text-gray-500">
              Update your personal information and contact details.
            </p>
          </div>
          <div className="card-body">
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  First name
                </label>
                <input type="text" className="input mt-1" placeholder="First name" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Last name
                </label>
                <input type="text" className="input mt-1" placeholder="Last name" />
              </div>
              <div className="sm:col-span-2">
                <label className="block text-sm font-medium text-gray-700">
                  Email
                </label>
                <input type="email" className="input mt-1" placeholder="Email address" />
              </div>
              <div className="sm:col-span-2">
                <label className="block text-sm font-medium text-gray-700">
                  Company
                </label>
                <input type="text" className="input mt-1" placeholder="Company name" />
              </div>
            </div>
          </div>
          <div className="card-footer">
            <button className="btn btn-primary">
              Save Changes
            </button>
          </div>
        </div>

        {/* Gmail Integration */}
        <div className="card">
          <div className="card-header">
            <h3 className="text-lg leading-6 font-medium text-gray-900">
              Gmail Integration
            </h3>
            <p className="mt-1 text-sm text-gray-500">
              Connect your Gmail account to sync contacts and emails.
            </p>
          </div>
          <div className="card-body">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-900">Gmail Account</p>
                <p className="text-sm text-gray-500">Not connected</p>
              </div>
              <button className="btn btn-outline">
                Connect Gmail
              </button>
            </div>
          </div>
        </div>

        {/* Notifications */}
        <div className="card">
          <div className="card-header">
            <h3 className="text-lg leading-6 font-medium text-gray-900">
              Notifications
            </h3>
            <p className="mt-1 text-sm text-gray-500">
              Manage your notification preferences.
            </p>
          </div>
          <div className="card-body">
            <div className="space-y-4">
              <div className="flex items-center">
                <input
                  id="email-notifications"
                  name="email-notifications"
                  type="checkbox"
                  className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
                />
                <div className="ml-3">
                  <label htmlFor="email-notifications" className="text-sm font-medium text-gray-700">
                    Email notifications
                  </label>
                  <p className="text-sm text-gray-500">Get notified about new contacts and deals.</p>
                </div>
              </div>
              <div className="flex items-center">
                <input
                  id="task-reminders"
                  name="task-reminders"
                  type="checkbox"
                  className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
                />
                <div className="ml-3">
                  <label htmlFor="task-reminders" className="text-sm font-medium text-gray-700">
                    Task reminders
                  </label>
                  <p className="text-sm text-gray-500">Receive reminders for upcoming tasks.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
